import Vue from 'vue'

import './styles/quasar.scss'
import 'quasar/dist/quasar.ie.polyfills'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QColor,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  Loading,
  QItemSection,
  QItemLabel,
  QDialog,
  ClosePopup,
  QCard,
  QFooter,
  QCardSection,
  QCardActions,
  Ripple,
  QInput,
  QForm,
  Notify,
  QAvatar,
  QSpinnerFacebook,
  QSpace,
  QScrollArea,
  QTooltip,
  QSeparator,
  QBadge,
  QTabs,
  QTab,
  QTabPanels,
  QTabPanel,
  QMenu,
  QBtnDropdown,
  QImg,
  QStepper,
  QStep,
  QStepperNavigation,
  QSelect,
  QSkeleton,
  QToggle,
  QPageSticky,
  QInfiniteScroll,
  QChip,
  QTable,
  QTh,
  QTr,
  QTd,
  QCheckbox,
  QPopupProxy,
  QDate,
  QBanner,
  QRange,
  QField,
  QPagination,
  QBtnGroup,
  QExpansionItem,
  QInnerLoading, Dialog
} from 'quasar'

Vue.use(Quasar, {
  config: {
    loading: {
      delay: 2000,
      spinner: 'QSpinnerFacebook',
      spinnerSize: '60',
      spinnerColor: 'primary'
    },
    Ripple,
    notify: {}
  },
  components: {
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QFooter,
    QExpansionItem,
    QColor,
    QRange,
    QField,
    QBanner,
    QDate,
    QBtnGroup,
    QPopupProxy,
    QCheckbox,
    QStepper,
    QStep,
    QBtnDropdown,
    QImg,
    QMenu,
    QBadge,
    QTooltip,
    QSeparator,
    QScrollArea,
    QSpace,
    QStepperNavigation,
    QForm,
    QInput,
    QCard,
    QCardSection,
    QCardActions,
    QLayout,
    QDialog,
    ClosePopup,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QSpinnerFacebook,
    QAvatar,
    QSelect,
    QSkeleton,
    QToggle,
    QPageSticky,
    QInfiniteScroll,
    QChip,
    QTable,
    QTh,
    QTr,
    QTd,
    QPagination,
    QInnerLoading
  },
  directives: {
    Quasar,
    ClosePopup,
    Ripple
  },
  plugins: {
    Loading,
    Notify,
    Dialog
  },
  iconSet: iconSet
})
